import { render, staticRenderFns } from "./swap.vue?vue&type=template&id=72d9d3e8&scoped=true&"
import script from "./swap.vue?vue&type=script&lang=js&"
export * from "./swap.vue?vue&type=script&lang=js&"
import style0 from "./swap.vue?vue&type=style&index=0&id=72d9d3e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d9d3e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72d9d3e8')) {
      api.createRecord('72d9d3e8', component.options)
    } else {
      api.reload('72d9d3e8', component.options)
    }
    module.hot.accept("./swap.vue?vue&type=template&id=72d9d3e8&scoped=true&", function () {
      api.rerender('72d9d3e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "pages/swap.vue"
export default component.exports